import React, { useState, FC } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { SmallPanel } from 'src/common/ui/small-panel';

interface DashboardHomeNotificationPanelProps
  extends Pick<
    JourneyMenuPropsInterface,
    'openRef' | 'closeRef' | 'renderOrigin' | 'onOpen' | 'onClose' | 'placement'
  > {
  onChange: (checked: boolean) => void;
  onSessionChange: (checked: boolean) => void;
  isEnabled: boolean;
  isSessionEnabled: boolean;
  onBack: () => void;
}

export const DashboardHomeNotificationPanel: FC<DashboardHomeNotificationPanelProps> = ({
  onChange,
  onSessionChange,
  isEnabled,
  isSessionEnabled,
  onBack,
  children,
  ...popoverProps
}) => {
  const [isNotificationsEnabled, setIsNotificationsEnabled] = useState(isEnabled);
  const [isSessionNotificationsEnabled, setIsSessionNotificationsEnabled] = useState(isSessionEnabled);

  const onNotificationChanged = (checked: boolean) => {
    setIsNotificationsEnabled(checked);
    onChange(checked);
  };

  const onSessionNotificationChanged = (checked: boolean) => {
    setIsSessionNotificationsEnabled(checked);
    onSessionChange(checked);
  };

  return (
    <SmallPanel openAfterMount hasBackButton onBack={onBack} {...popoverProps}>
      <div className='flex flex-col space-y-md'>
        <ToggleComponent
          checked={isNotificationsEnabled}
          onChange={onNotificationChanged}
          label='Get email notifications when this Journey is opened'
        />
         <ToggleComponent
          checked={isSessionNotificationsEnabled}
          onChange={onSessionNotificationChanged}
          label='Get email notifications when you have session replays for this Journey'
        />
        {children}
      </div>
    </SmallPanel>
  );
};
